(() => {
  'use strict';

  const PRODUCT_HANDLE = 'persoonlijke-boodschap';
  const EXPECTED_PRICE = 350;
  const shopRoot = window.Shopify?.routes?.root || '/';
  const apiPath = (path) => `${shopRoot.replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
  let busy = false;
  let dirty = false;

  const jsonRequest = async (path, options = {}) => {
    const response = await fetch(apiPath(path), {
      credentials: 'same-origin',
      ...options,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...(options.headers || {}),
      },
    });
    const raw = await response.text();
    let data = {};
    try { data = raw ? JSON.parse(raw) : {}; } catch (_error) { data = {}; }
    if (!response.ok || data.status === 422 || data.errors) {
      const message = typeof data.errors === 'string'
        ? data.errors
        : data.description || data.message || (typeof data.errors === 'object' ? Object.values(data.errors).flat().join(' ') : '');
      const unavailableProduct = path.includes(`products/${PRODUCT_HANDLE}`) || path.includes('cart/add');
      throw new Error(message || (unavailableProduct
        ? 'Het product Persoonlijke boodschap is niet beschikbaar in het verkoopkanaal Onlinewinkel.'
        : `Shopify kon de winkelwagen niet bijwerken (${response.status}).`));
    }
    return data;
  };

  const post = (path, body) => jsonRequest(path, { method: 'POST', body: JSON.stringify(body) });
  const wrapper = () => document.querySelector('[data-mb-personal-message]');
  const footerInput = () => document.querySelector('[data-mb-message-footer-input]');

  const setStatus = (message, isError = false) => {
    document.querySelectorAll('[data-mb-personal-message-status]').forEach((node) => {
      node.textContent = message;
      node.classList.toggle('mb-personal-message__status--error', isError);
    });
  };

  const setBusy = (value) => {
    busy = value;
    wrapper()?.classList.toggle('is-loading', value);
    wrapper()?.setAttribute('aria-busy', String(value));
    document.querySelectorAll('[data-mb-message-save], [data-mb-message-remove]').forEach((button) => {
      button.disabled = value;
    });
  };

  const setInput = (value) => {
    const input = footerInput();
    if (input) input.value = value;
  };

  const resolveVariant = async () => {
    const container = wrapper();
    let id = Number(container?.dataset.mbPersonalMessageVariantId) || 0;
    let price = Number(container?.dataset.mbPersonalMessagePrice) || 0;
    if (id && price === EXPECTED_PRICE) return id;

    const product = await jsonRequest(`products/${PRODUCT_HANDLE}.js`);
    const variant = product.variants?.find((entry) => entry.available) || product.variants?.[0];
    if (!variant) throw new Error('Het product Persoonlijke boodschap is niet beschikbaar.');
    id = Number(variant.id);
    price = Number(variant.price);
    if (price !== EXPECTED_PRICE) throw new Error('De prijs van Persoonlijke boodschap moet €3,50 zijn.');
    if (container) {
      container.dataset.mbPersonalMessageVariantId = String(id);
      container.dataset.mbPersonalMessagePrice = String(price);
    }
    return id;
  };

  const feeItems = (cart, variantId = 0) => (cart.items || []).filter((item) =>
    item.handle === PRODUCT_HANDLE
    || item.properties?._matchboox_personal_message_fee === 'true'
    || (variantId && Number(item.variant_id) === Number(variantId))
  );

  const persist = async (message, { forcedRemoveKey = '', reload = true } = {}) => {
    if (busy) return false;
    const note = String(message || '').trim();
    setBusy(true);
    setStatus(note ? 'De persoonlijke boodschap wordt opgeslagen…' : 'De persoonlijke boodschap wordt verwijderd…');

    try {
      let cart = await jsonRequest('cart.js');
      let variantId = 0;
      let items = feeItems(cart);

      if (note && !items.length) {
        variantId = await resolveVariant();
        await post('cart/add.js', {
          items: [{ id: variantId, quantity: 1, properties: { _matchboox_personal_message_fee: 'true' } }],
        });
        cart = await jsonRequest('cart.js');
        items = feeItems(cart, variantId);
      }

      if (note) {
        if (!items.length) throw new Error('De toeslag voor de persoonlijke boodschap kon niet worden toegevoegd.');
        if (items[0].quantity !== 1) await post('cart/change.js', { id: items[0].key, quantity: 1 });
        for (const item of items.slice(1)) await post('cart/change.js', { id: item.key, quantity: 0 });
      } else {
        for (const item of items) await post('cart/change.js', { id: item.key, quantity: 0 });
        if (forcedRemoveKey && !items.some((item) => item.key === forcedRemoveKey)) {
          await post('cart/change.js', { id: forcedRemoveKey, quantity: 0 });
        }
      }
      await post('cart/update.js', { note });
      dirty = false;
      setInput(note);
      setStatus(note ? 'Persoonlijke boodschap opgeslagen.' : 'Persoonlijke boodschap verwijderd.');
      if (reload) window.location.reload();
      return true;
    } catch (error) {
      setStatus(error.message || 'De persoonlijke boodschap kon niet worden bijgewerkt.', true);
      return false;
    } finally {
      setBusy(false);
    }
  };

  document.addEventListener('input', (event) => {
    const input = event.target.closest?.('[data-mb-message-footer-input]');
    if (!input) return;
    dirty = true;
    setStatus('');
  });

  document.addEventListener('click', async (event) => {
    const saveButton = event.target.closest?.('[data-mb-message-save]');
    if (saveButton) {
      event.preventDefault();
      const source = footerInput();
      if (source) await persist(source.value);
      return;
    }

    const removeButton = event.target.closest?.('[data-mb-message-remove]');
    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      setInput('');
      await persist('', { forcedRemoveKey: removeButton.dataset.mbMessageKey || '' });
    }
  });

  document.addEventListener('click', async (event) => {
    const checkoutButton = event.target.closest?.('#checkout');
    if (!checkoutButton || !dirty || busy) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const completed = await persist(footerInput()?.value || '', { reload: false });
    if (completed) window.location.assign(apiPath('checkout'));
  }, true);
})();
